module.exports = __webpack_public_path__ + "img/esg_card.11977ec9.png";